module.exports = {"532328101":"元马镇","532328103":"黄瓜园镇","532328104":"羊街镇","532328202":"老城乡","532328203":"物茂乡","532328204":"江边乡","532328205":"新华乡","532328206":"平田乡","532328209":"凉山乡","532328210":"姜驿乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532328.json
// module id = 2430
// module chunks = 0